import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const clientToken = process.env.REACT_APP_CLIENT_TOKEN;

const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    "x-gss-api": clientToken,
  },
});

export const openApi = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "x-gss-api": clientToken,
  },
});

let isRefreshing = false;
let refreshSubscribers = [];

const onRefreshed = (token) => {
  refreshSubscribers.forEach((callback) => callback(token));
  refreshSubscribers = [];
};

const addRefreshSubscriber = (callback) => {
  refreshSubscribers.push(callback);
};

api.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      (error.response?.status === 401 || error.response?.status === 403) &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      if (!isRefreshing) {
        isRefreshing = true;

        try {
          const { data } = await axios.post(
          `${BASE_URL}/account/panel/refresh`,
            {},
            {
              withCredentials: true,
              headers: {
                "Content-Type": "application/json",
                "x-gss-api": clientToken,
              },
            }
          );

          const newToken = data.access;
          localStorage.setItem("accessToken", newToken);

          onRefreshed(newToken);

          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return api(originalRequest);

        } catch (refreshError) {
          console.log("refresh error");
          
           window.location.assign("/login");
          // alert("Session expired, please login again");
          isRefreshing = false;

          localStorage.removeItem("accessToken");

           const allowedPaths = ['/login','/forgotpassword', '/set-password'];
          if (
            !allowedPaths.some((path) =>
              window.location.pathname.startsWith(path)
            )
          ) {
            // Simple alert before redirect
            // alert("Session expired, please login again");
           
          }

          return Promise.reject(refreshError);
        } finally {
          isRefreshing = false;
        }
      }

      return new Promise((resolve, reject) => {
        addRefreshSubscriber((token) => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          resolve(api(originalRequest));
        });
      });
    }

    return Promise.reject(error);
  }
);

export default api;
